import { Environment, Region } from '@bringg/frontend-utils/dist/common/types';

const DEFAULT_REGION = 'default_region';

export default class RegionService {
	private readonly configuration: Environment;

	constructor(config: Environment) {
		this.configuration = config;
	}

	getConfigByRegion(): Region {
		let regionId = Number(this.getRegionFromUrl());
		const regions = this.configuration?.regions;
		if (regionId === 1) {
			regionId = 7;
		}
		const region = regions && Object.values(regions).find(region => region['id'] === regionId);
		return region || this.getDefaultRegion();
	}

	private getDefaultRegion(): Region {
		return this.configuration.regions[this.configuration[DEFAULT_REGION]];
	}

	private getRegionFromUrl() {
		const urlParams = new URLSearchParams(window.location.hash);

		if (urlParams) {
			return urlParams.get('e');
		}
	}
}
